export class ListaFiltros {
  readonly elementos: JSX.Element[];

  constructor() {
    this.elementos = [];
  }

  public add(elemento: JSX.Element|JSX.Element[]|null) {
    if (Array.isArray(elemento)) {
      this.elementos.concat(elemento);
    } else if (elemento !== null) {
      this.elementos.push(elemento);
    }
  }
}